import React from 'react'

export const UserContext = React.createContext({
    me : false,
    documentStore : false,
    selectedBrand : false,
    setSelectedBrand : function () {}
})
